<template>
  <v-card>
    <v-toolbar class="card-bar">
      <v-toolbar-title>Checklists Venc./Pend.</v-toolbar-title>
      <v-spacer />
      <div class="tag purple  mr-4">{{ vencidoPct }}</div>
      <div class="tag yellow">{{ pendentePct }}</div>
      <v-spacer />
      <v-btn icon @click="reload">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <ODataGrid
      v-if="gridData != null"
      class="report-grid dense-table"
      :data="gridData"
      :limits="limits"
      :limit.sync="limit"
      :offset.sync="offset"
      @rowClicked="showRowDetails"
    />
  </v-card>
</template>

<script>
import { go } from '@/models'
import grid from 'oderon-commons/src/grid'
import { preProcessSpec } from 'oderon-commons/src/tables'
import ODataGrid from 'oderon-vue/cpts/ODataGrid.vue'
import { statusSummary, statusStyle, dateAndTimeAgo } from './utils'
import utils from 'oderon-commons/src/utils'

export default {
  components: { ODataGrid },
  data() {
    return {
      gridData: null,
      limits: [10, 50, 300, 1000],
      offset: 0,
      limit: 10,
      adapterSpec: preProcessSpec({
        columns: [
          { t: 'Módulo', d: 'client.id', sortBy: false },
          { t: 'Veículo', d: 'vehicle.code', sortBy: false },
          {
            t: 'Último checklist|',
            d: 'client.lastChecklist.at',
            f: dateAndTimeAgo,
            sortBy: false
          },
          {
            w: 170,
            t: '|Status|',
            d: 'status',
            cellStyleFn: (row) => statusStyle(row.status),
            sortBy: false
          }
        ]
      }),

      stats: null
    }
  },
  computed: {
    vencidoPct() {
      return statusSummary(this.stats, 'ChecklistVencido')
    },
    pendentePct() {
      return statusSummary(this.stats, 'ChecklistNecessario')
    },
    paging() {
      return { limit: this.limit, offset: this.offset }
    }
  },
  watch: {
    paging() {
      this.fetchData()
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    reload() {
      this.fetchData()
    },
    async fetchData() {
      const { rows, count } = await go.get('/installed-base', {
        status: 'ChecklistVencido,ChecklistNecessario',
        hideExemplo: true
      })

      const opts = { offset: this.offset, limit: this.limit }
      const spec = this.adapterSpec

      const sorted = utils.orderBy(rows, [['client.lastChecklist.at', 'asc']])
      this.gridData = grid.generateWebGrid({ rows: sorted, spec, count, opts })

      this.stats = await go.get('/installed-base/stats')
    },

    showRowDetails(row, idx, isMiddle) {
      this.$emit('rowClicked', { row, isMiddle })
    }
  }
}
</script>

<style></style>
